import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./ConnectionHistory.module.css";
import {
  fetchConnectionHistory,
  fetchDocumentHistory,
} from "../../../../Redux/Slices/bankingSlice";
import { getDocumentUrlByLedgerId } from "../../../../Services/ApiCalling/banking";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import Loader from "../../../../commons/Loader/Loader";
import ViewInjectDrawal from "../ViewInjectDrawal/ViewInjectDrawal";
import InfoExchanged from "../InfoExchanged/InfoExchanged";
import { openBilateralChat } from "../CreateEdit/helpers";

const ConnectionHistory = ({ connectionId, open, handleClose, listingId }) => {
  const dispatch = useDispatch();

  const bankingState = useSelector((state) => state.bankingSlice || {});
  const { connectionData, loading, error } = bankingState;

  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const [selectedListingData, setSelectedListingData] = useState([]);

  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [selectedConnectionId, setSelectedConnectionId] = useState(null);

  useEffect(() => {
    if (connectionId) {
      dispatch(fetchConnectionHistory(connectionId));
    }
  }, [dispatch, connectionId]);

  const handleViewDoc = async (id) => {
    try {
      const response = await getDocumentUrlByLedgerId(id);
      const url = response.data;
      if (url) {
        window.open(url, "_blank", "noopener");
      } else {
        alert("Document URL not found");
      }
    } catch (err) {
      alert("Could not fetch document URL.");
    }
  };

  const handleInfoClick = (id) => {
    setSelectedConnectionId(id);
    setInfoModalOpen(true);
  };

  const handleViewDetailsClick = (listing) => {
    setSelectedListingData([listing]);
    setViewDetailsOpen(true);
  };

  const handleChatOpen = (fromUser, toUser) => {
    openBilateralChat(dispatch, {
      header: toUser,
      fromUser,
      toUser,
    });
  };

  return (
    <>
      <ViewInjectDrawal
        data={selectedListingData}
        open={viewDetailsOpen}
        handleClose={() => setViewDetailsOpen(false)}
      />

      <InfoExchanged
        open={infoModalOpen}
        handleClose={() => setInfoModalOpen(false)}
        connectionId={selectedConnectionId}
        listingId={listingId}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading  ${Styles.modalHeading}`}
          >
            <div className="headingText">Connection History</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.docContainer}>
            <div className={Styles.viewConnectHis}>
              <div>Name</div>
              <div>Injection/Drawal Range</div>
              <div>SR</div>
              <div>BF</div>
              <div>Operation</div>
            </div>

            <div className={Styles.docContentScroll}>
              {loading ? (
                <div className={Styles.loadingRow}>
                  <Loader />
                </div>
              ) : error ? (
                <p className={Styles.error}>{error}</p>
              ) : Array.isArray(connectionData) && connectionData.length > 0 ? (
                connectionData.map((doc) => (
                  <div className={Styles.docRow} key={doc.id}>
                    <div style={{ width: "13%" }}>
                      {doc.againstBankingListing?.companyName || "-"}
                    </div>

                    <div
                      style={{ width: "26%", cursor: "pointer" }}
                      onClick={() =>
                        handleViewDetailsClick(doc.againstBankingListing)
                      }
                    >
                      View Details
                    </div>

                    <div style={{ width: "13%" }}>
                      {doc.againstBankingListing?.settlementRate || "-"}
                    </div>

                    <div style={{ width: "15%" }}>
                      {doc.againstBankingListing?.bankingFactor != null
                        ? `${doc.againstBankingListing.bankingFactor}%`
                        : "-"}
                    </div>

                    <div className={`${Styles.connectionBtns}`}>
                      <div
                        className={Styles.chatBtn}
                        onClick={() =>
                          handleChatOpen(
                            doc.selfBankingListing?.name || "-",
                            doc.againstBankingListing?.name || "-"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Chat History
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className={Styles.connectHistory}>
                  No connection history found.
                </div>
              )}
            </div>

            {/* <div className={Styles.docContentScroll}>
              <div className={Styles.connectTable}>
                <div>GreenEnergy</div>
                <div>view details</div>
                <div>DAM+2</div>
                <div>34%</div>
                <div>
                  <div className={Styles.chatBtn}>Chat</div>
                  <div className={Styles.infoBtn}>Information Exchanged</div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ConnectionHistory;
